import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { DrawerRegistryService } from '../../../shared/services/drawer-registry.service';

/**
 * Opciones para abrir la ventana flotante de WhatsApp. Mismo contrato que
 * EmailComposeOptions: cualquier listado o detalle de contacto puede abrirla con
 * el destinatario ya cargado para que el usuario solo elija el mensaje.
 */
export interface WhatsappComposeOptions {
  /** Teléfono del destinatario. Si viene, se precarga. */
  phone?: string;
  /** Nombre legible del destinatario (para el chip y para rellenar el mensaje). */
  fullName?: string;
  /** Id del contacto del CRM. */
  contactId?: number;
}

export interface WhatsappComposeState {
  isOpen: boolean;
  options: WhatsappComposeOptions;
}

/**
 * Servicio GLOBAL de la ventana de WhatsApp, gemelo de {@link EmailComposeService}.
 * El componente flotante se monta UNA vez en el shell y se suscribe a `state$`.
 *
 * Apertura: acciones rápidas del contacto, y cualquier otro sitio que tenga un
 * teléfono a mano → `open(options?)`.
 */
@Injectable({ providedIn: 'root' })
export class WhatsappComposeService {
  private readonly registry = inject(DrawerRegistryService);
  private readonly stateSubject = new BehaviorSubject<WhatsappComposeState>({
    isOpen: false,
    options: {},
  });
  readonly state$ = this.stateSubject.asObservable();

  /** Emite cuando el mensaje salió, para que la bandeja de WhatsApp refresque. */
  private readonly sentSubject = new Subject<void>();
  readonly sent$ = this.sentSubject.asObservable();

  open(options: WhatsappComposeOptions = {}): void {
    if (!this.stateSubject.value.isOpen) this.registry.opened();
    this.stateSubject.next({ isOpen: true, options });
  }

  close(): void {
    if (this.stateSubject.value.isOpen) this.registry.closed();
    this.stateSubject.next({ isOpen: false, options: {} });
  }

  notifySent(): void {
    this.sentSubject.next();
  }
}
